import moment from 'moment';

const formatTimePlugin = {
  install(Vue) {
    Vue.prototype.$formatTime = function(seconds) {
      const duration = moment.duration(seconds, 'seconds');
      const hours = String(duration.hours()).padStart(2, '0');
      const minutes = String(duration.minutes()).padStart(2, '0');
      const secondsValue = String(duration.seconds()).padStart(2, '0');
      return `${hours}:${minutes}:${secondsValue}`;
    };
  }
};

export default formatTimePlugin;